<template>
  <div v-if="chartData" class="RadarApexChart">
    <apexchart type="radar" height="500px" width="500px" :options="chartData.chartOptions" :series="chartData.values"></apexchart>
  </div>
  <p v-else>{{chartData}}</p>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import i18n from '@/lib/i18n'

const reverseArray = (array) => {
  const revArray = []
  array.forEach(val => revArray.unshift(val))
  return revArray
}
const getChartOptions = (chartData, subOptions, emitData) => {
  let values = [...chartData.values]
  values = values.filter((val, i) => subOptions[i].checked)
  values = reverseArray(values)

  let colors = ['#000000', '#F93A2F', '#0098E1', '#52B847']
  colors = colors.filter((val, i) => subOptions[i].checked)
  colors = reverseArray(colors)

  return {
    chartOptions: {
      legend: {
        show: false
      },
      fill: {
        colors,
        opacity: 0
      },
      stroke: {
        colors,
        width: 4
      },
      dataLabels: {
        enabled: false
      },
      chart: {
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        events: {
          markerClick (e, chartContext, { seriesIndex, dataPointIndex }) {
            const data = []

            data.push([`${i18n.t('PressureChart.angle')}:`, `${(dataPointIndex * 360 / values[0].data.length).toFixed(0)}°`])

            data.push([`${i18n.t('PressureChart.pressure')}:`, `${values[seriesIndex].data[dataPointIndex]} bar`])

            data.push([`${i18n.t('PressureChart.category')}:`, `<p style="color: ${colors[seriesIndex]} font-weight: 600">${values[seriesIndex].name}</p>`])

            emitData(data)
          }
        }
      },
      xaxis: {
        labels: {
          show: false
        }
      },
      yaxis: {
        labels: {
          formatter (val) {
            return `${val.toFixed(1).replace(/\.0+$/, '')} ${i18n.t('PressureChart.barUnit')}`
          }
        },
        min: 0,
        max: chartData.maxValue + 0.5,
        tickAmount: 4
      },
      markers: {
        size: 2,
        colors: colors,
        strokeColors: '#00000000'
      },
      tooltip: {
        show: true,
        y: {
          formatter (value) {
            return `${value.toFixed(2)} ${i18n.t('PressureChart.barUnit')}`
          },
          title: {
            formatter () {
              return ''
            }
          }
        },
        x: {
          formatter (value, { series }) {
            const scale = 360 / series[0].length
            return `${((value - 1) * scale).toFixed(0)}°`
          }
        }
      }
    },
    values
  }
}
const parsePressureData = (csvData, bookPressure) => {
  let pressureCsvLines = csvData.split('\n') // CSV Input
  let pressures
  let line
  const seriesArrayValues = [{
    name: i18n.t('PressureChart.book'),
    data: []
  }, {
    name: i18n.t('PressureChart.minimum'),
    data: []
  },
  {
    name: i18n.t('PressureChart.average'),
    data: []
  },
  {
    name: i18n.t('PressureChart.maximum'),
    data: []
  }]
  for (let i = 0; i < 36; i++) {
    seriesArrayValues[0].data[i] = 0
    seriesArrayValues[1].data[i] = 0
    seriesArrayValues[2].data[i] = 0
    seriesArrayValues[3].data[i] = 0
  }
  for (let j = 1; j < pressureCsvLines.length; j++) {
    line = pressureCsvLines[j]
    pressures = line.split(';')
    let count = 0
    pressures = pressures.slice().reverse()
    if (pressures.length >= 3) {
      for (let i = 0; count < 3; i++) {
        if (i === 0) {
          seriesArrayValues[3].data[j - 1] = pressures[i].replace(',', '.')
        } else if (i === 1) {
          seriesArrayValues[2].data[j - 1] = pressures[i].replace(',', '.')
        } else {
          seriesArrayValues[1].data[j - 1] = pressures[i].replace(',', '.')
        }
        count++
      }
    }
  }

  if (bookPressure) {
    for (let i = 0; i < pressureCsvLines.length - 1; i++) {
      if (seriesArrayValues[3].data[i] !== '0.00') {
        seriesArrayValues[0].data[i] = bookPressure
      } else {
        seriesArrayValues[0].data[i] = 0
      }
    }
  }
  let maxValues = []
  maxValues.push(Math.max(...seriesArrayValues[0].data))
  maxValues.push(Math.max(...seriesArrayValues[1].data))
  maxValues.push(Math.max(...seriesArrayValues[2].data))
  maxValues.push(Math.max(...seriesArrayValues[3].data))
  let maxValue = Math.max(...maxValues)

  return {
    values: seriesArrayValues,
    maxValue
  }
}

export default {
  props: ['subOptions', 'circularData'],
  components: {
    apexchart: VueApexCharts
  },
  methods: {
    emitData (data) {
      this.$emit('onClickMarker', data)
    }
  },
  computed: {
    chartData () {
      if (!this.circularData.pressure_data) {
        return null
      }
      return getChartOptions(parsePressureData(this.circularData.pressure_data, this.circularData.book_pressure), this.subOptions, this.emitData)
    }
  }
}
</script>


// WEBPACK FOOTER //
// PressureChart.vue?0ec19a5d